<template>
  <Modal width="1080" v-model="show" :mask-closable="false"  :loading="loading">
      <div slot="header" class="modal-header">添加云钉智能设备</div>
      <Form :model="formData" :label-width="130" :rules="formRules" ref="formValidate">
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="项目名称" prop="projectFid">
              <Select v-model="formData.projectFid" @on-change="changeProject">
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="楼栋" prop="houseBuildingFid">
              <Select v-model="formData.houseBuildingFid" @on-change="changeBuilding">
                <Option  v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col :span="8">
            <FormItem label="设备类型" prop="prodTypeId">
              <Select class="select-width" v-model="formData.prodTypeId">
                <Option value="">请选择</Option>
                <Option v-for="(item,index) in deviceTypeEnum" :value="item.value" :key="'device'+index">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col :span="24">
            <div class="flex">
              <div class="roomlist">
                <h4 class="mb8">房间列表</h4>
                <Tabs type="card">
                  <Tab-pane label="整租">
                    <ul>
                      <li v-for="(item,index) in canSelect"
                          :class="['top','ivu-btn',{'btn-primary2':item.isSelected}]"
                          :key="'keyA'+index"
                          @click.stop="selectItem(item)"
                      >{{item.stockNumber}}
                      </li>
                    </ul>
                  </Tab-pane>
                  <!-- <Tab-pane label="合租">
                    <ul>
                      <li v-for="(item,index) in canSelect2"
                          :class="['ivu-btn',{'btn-primary2':item.isSelected}]"
                          :key="'keyA'+index"
                          @click.stop="selectItem(item)"
                      >{{item.stockNumber}}
                      </li>
                    </ul>
                  </Tab-pane> -->
                   <Tab-pane label="合租">
                    <ul>
                      <li class="top" v-for="(item,index) in canSelect2" :key="'keyA'+index">
                        <span :class="['icon-arrow ivu-icon',item.switch?'ivu-icon-arrow-down-b':'ivu-icon-arrow-right-b']" style="display:inline-block" @click="getSmall(index,item.fid)"></span>
                        <span :class="['ivu-btn',{'btn-primary2':item.isSelected}]" @click.stop="selectItem(item,index)">{{item.stockNumber}}</span>
                        <!-- <div> -->
                        <span
                          v-if="item.switch"
                          style="margin-left:10px;margin-top:10px"
                          v-for="(item2,index2) in item.canSelectSmall2" :key="'a'+index2"
                          :class="['ivu-btn',{'btn-primary2':item2.isSelected}]"
                          @click.stop="selectItem(item2,index)"
                        >
                        {{item2.stockNumber}}
                        </span>
                        <!-- </div> -->
                      </li>
                    </ul>
                  </Tab-pane>
                </Tabs>
              </div>
              <div class="checklist">
                <h4 class="mb8">已选列表</h4>
                <Tabs type="card">
                  <Tab-pane label="整租">
                    <ul>
                      <li v-for="(item,index) in checkList" class="top ivu-btn btn-primary2"
                          :key="'keyB'+index"
                          @click.stop="selectItem(item)"
                      >{{item.stockNumber}}
                      </li>
                    </ul>
                  </Tab-pane>
                  <!-- <Tab-pane label="合租">
                    <ul>
                      <li v-for="(item,index) in checkList2" class="ivu-btn btn-primary2"
                          :key="'keyB'+index"
                          @click.stop="selectItem(item)"
                      >{{item.stockNumber}}
                      </li>
                    </ul>
                  </Tab-pane> -->
                  <Tab-pane label="合租">
                    <ul>
                      <li style="width:500px" v-for="(item,index) in canSelect2" :key="'keyA'+index">
                        <!-- <span v-if="item.isSelected" class="icon-arrow" style="display:inline-block" @click="getSmall(index,item.fid)"></span> -->
                        <span class="rightBtn" v-if="item.isSelected" :class="['ivu-btn',{'btn-primary2':item.isSelected}]" @click.stop="selectItem(item)">{{item.stockNumber}}</span>
                        <!-- <div> -->
                        <span
                          class="rightBtn"
                          v-for="(item2,index2) in item.canSelectSmall2" :key="'a'+index2"
                          :class="['ivu-btn',{'btn-primary2':item2.isSelected}]"
                          @click.stop="selectItem(item2)"
                          v-if="item2.isSelected"
                        >
                        {{item2.stockNumber}}
                        </span>
                        <!-- </div> -->
                      </li>
                    </ul>
                  </Tab-pane>
                </Tabs>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading">
          <span v-if="!loading">保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </Modal>
</template>

<script type="text/ecmascript-6">
import FurnitureItem from './FurnitureItem'
import SelectRoom from './SelectRoom'
import {formatDateTime} from "@/utils/format"
import { fuzzyRoom } from 'api/functionalArea'
import { getDeviceType, addDevice ,parentListNoPage,subList} from "api/smartWorkOrder"
import {  addStock } from "api/house"
import {  canSelectStock } from "api/outHouse"
export default {
  components:{
    FurnitureItem,
    SelectRoom
  },
  props: {
    n: {
      type: Number,
      default: 0
    },
    projectList:{
       type:Array,
       default:[]
    },
  },
  watch: {
		n() {
      this.$refs['formValidate'].resetFields();
			this.loading = false
      this.show = true;
      this.formData.projectFid = this.projectList[0].value
      this.formData.stockFids = [];
    },
    canSelect:{
      deep:true,
      handler(){
        this.checkList =  this.canSelect.filter(ele => {
          return ele.isSelected
          })
        this.stockFids = this.checkList.map(ele => {
          return ele.fid
        })
        if(this.stockFids.length>0){
          this.zhengzu = true
        } else{
          this.zhengzu = false
        }
      }
    },
    canSelect2:{
      deep:true,
      handler(){
        this.checkList2 =  this.canSelect2.filter(ele => {
          return ele.isSelected
        })
        this.checkListSmall2 = [];
        this.canSelect2.forEach(ele=>{
          if(ele.hasOwnProperty('canSelectSmall2')){
            this.checkListSmall2 = this.checkListSmall2.concat(ele.canSelectSmall2.filter(e=>{
              return e.isSelected;
            }))
          }
          return false
        })
        this.checkHeZu = this.checkList2.concat(this.checkListSmall2);
        this.stockFids2 = this.checkHeZu.map(ele => {
          return ele.fid
        })
        if(this.stockFids2.length>0){
          this.hezu = true
        } else{
          this.hezu = false
        }
      }
    },
  },
  created(){
    getDeviceType().then(res => {
      if(res.data){
        this.deviceTypeEnum = res.data.deviceType
      }
    }).catch(error => {
    })
  },
  // computed: {
  //   stockFids() {
  //     let ret = []
  //     this.checkList.forEach(ele => {
  //       ret.push(ele.fid)
  //     })
  //     console.log(ret,'rettttt')
  //     return ret
  //   },
  //   stockFids2() {
  //     let ret = []
  //     this.checkList2.forEach(ele => {
  //       ret.push(ele.fid)
  //     })
  //     return ret
  //   },
  //   checkList() {
  //     return this.canSelect.filter(ele => {
  //       return ele.isSelected
  //     })
  //   },
  //   checkList2() {
  //     return this.canSelect2.filter(ele => {
  //       return ele.isSelected
  //     })
  //   },
  // },
  data () {
    return {
      hasDone:[],
      checkList:[],
      checkList2:[],
      checkListSmall2:[],
      show:false,
      loading:false,
      stockRentType:0,
      deviceTypeEnum:[],
      buildingList:[],
      canSelect: [],
      canSelect2: [],
      formData: {
        projectFid: "",
        houseBuildingFid: "",
        prodTypeId: "",
        stockFids:[],
      },
      formRules:{
        projectFid:[{ required: true, type:'string', message:'请选择项目名称', trigger: 'change'}],
        houseBuildingFid:[{ required: true, type:'string', message:'请选择楼栋', trigger: 'change'}],
        prodTypeId:[{ required: true, type:'string', message:'请选择设备类型', trigger: 'change'}],
			},
    };
  },
  methods:{
    getSmall(index,id){
      this.canSelect2[index].switch = !this.canSelect2[index].switch;
      //已经请求过接口的就不要请求了
      if(this.hasDone.indexOf(index) > -1){
        return false
      }  
      this.hasDone.push(index);
      
      subList({'stockFid':id})
      .then(res => {
        this.canSelect2[index].canSelectSmall2 = res.data;
        this.canSelect2[index].canSelectSmall2.forEach(ele=>{
          ele['isSelected'] = false;
        })
        this.$forceUpdate();
      })
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    changeProject(value) {
      if(value === '') {
        this.buildingList = []
      }else{
        let project = this.projectList.find( item => {
          return item.value === value
        })
        if(project === undefined) {
          this.$Message.error('获取楼栋信息错误');
        } else {
          this.buildingList = project.children
          // this.formData.houseBuildingFid = this.buildingList[0].value
        }
      }
    },
    changeBuilding(value) {
      this.canSelect = []
      this.canSelect2 = []
      if(value) {
        this.getZhengzu();
        this.getHezu();
      }
    },
    getZhengzu(){
      let params = {
        projectFid: this.formData.projectFid,
        houseBuildingFid: this.formData.houseBuildingFid,
        stockRentType:0,
      }
      parentListNoPage(params).then(res => {
        if (res.data.length ===0) {
          this.$Message.info('整租不存在可选房间')
          return
        }
        res.data.forEach(ele => {
          ele['isSelected'] = false
        })
        this.canSelect = res.data
      }).catch(error => {
      })
    },
    getHezu(){
      let params = {
        projectFid: this.formData.projectFid,
        houseBuildingFid: this.formData.houseBuildingFid,
        stockRentType:1,
      }
      parentListNoPage(params).then(res => {
        if (res.data.length === 0) {
          // this.$Message.info('合租不存在可选房间')
          return
        }
        res.data.forEach(ele => {
          ele['isSelected'] = false
          ele['switch'] = false
        })
        this.canSelect2 = res.data
      }).catch(error => {
      })
    },
    canSelectStock() {
      let params = {}
      if(this.stockRentType === 0){
        params = {
          projectFid: this.formData.projectFid,
          houseBuildingFid: this.formData.houseBuildingFid,
          stockRentType:0,
        }
      } else{
        params = {
          projectFid: this.formData.projectFid,
          houseBuildingFid: this.formData.houseBuildingFid,
          stockRentType:1,
        }
      }
      parentListNoPage(params).then(res => {
        if (!res.data) {
          // this.$Message.info('不存在可选房间')
          return
        }
        res.data.forEach(ele => {
          ele['isSelected'] = false
        })
        this.canSelect = res.data
      }).catch(error => {
      })
    },
    
    // selectItem(item) {
    //   item.isSelected = !item.isSelected
    // },
    selectItem(item,index){
      item.isSelected = !item.isSelected
      this.canSelect2 = [].concat(this.canSelect2);
    },
   
    handleCancel(){
      this.show = false
    },
    save() {
      this.$refs['formValidate'].validate( bool => {
        if(bool){
          this.formData.stockFids = this.stockFids.concat(this.stockFids2);
          if(this.formData.stockFids.length === 0){
            this.$Message.info('请选择房间')
            this.loading = false
            return
          }
          if(this.formData.stockFids.length>30){
            this.$Message.info('最多可下单30个房间')
            this.loading = false
            return
          }
          this.loading = true

          addDevice(this.formData).then(res => {
            this.loading = false
            this.$Message.success('智能平台添加安装设备工单成功');
            this.$emit('refresh')
            this.show=false
          }).catch( res => {
            this.loading=false
            this.show = false
            this.$emit('refresh')
          })
        }
      });
    }
  }

}
</script>
<style scoped>
.icon-arrow{
  width: 10px;
  height: 10px;
}
  .flex {
    display: flex;
    border: 1px solid #DDDEE1;
  }

  .roomlist {
    flex: none;
    width: 49%;
    border-right: 1px solid #DDDEE1;
    padding: 15px;
  }

  .checklist {
    flex: auto;
    padding: 15px;
  }


    li.top {
    margin: 0 10px 10px 0; 
    width: 100px;
    float: left;
  }
  .rightBtn{
    width:80px;margin-left:10px;margin-top:10px
  }

</style>
